import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "probabilities";

export const getProbabilityScoresList = async (
	currentTenantKey: string,
	filter: any = {},
	sort: any = {}
) => {
	try {
		const response = await axios.get(`${url}/${currentTenantKey}/${apiURL}`, {
			params: { filter: JSON.stringify(filter), sort: JSON.stringify(sort) },
			...AuthHeader,
		});
		return response.data;
	} catch (error: any) {
		throw new Error(
			error.response?.data?.error || "Failed to fetch probability scores"
		);
	}
};

export const addProbabilityScoreItem = async (
	currentTenantKey: string,
	data: any
) => {
	try {
		const response = await axios.post(
			`${url}/${currentTenantKey}/${apiURL}`,
			data,
			AuthHeader
		);
		return response.data;
	} catch (error: any) {
		throw new Error(
			error.response?.data?.error || "Failed to add probability score"
		);
	}
};

export const updateProbabilityScoreItem = async (
	currentTenantKey: string,
	_id: string,
	data: any
) => {
	try {
		const req_body = {
			filter: { _id: _id },
			data: data,
			options: { upsert: true, new: true },
		};
		const response = await axios.put(
			`${url}/${currentTenantKey}/${apiURL}`,
			req_body,
			AuthHeader
		);
		return response.data;
	} catch (error: any) {
		throw new Error(
			error.response?.data?.error || "Failed to update probability score"
		);
	}
};

export const deleteProbabilityScoreItem = async (
	currentTenantKey: string,
	_id: string
) => {
	try {
		const response = await axios.delete(
			`${url}/${currentTenantKey}/${apiURL}`,
			{ params: { filter: JSON.stringify({ _id: _id }) }, ...AuthHeader }
		);
		return response.data;
	} catch (error: any) {
		throw new Error(
			error.response?.data?.error || "Failed to delete probability score"
		);
	}
};
